// extracted by mini-css-extract-plugin
export default {"illustration":"_1zKpy"};